import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { IMohFormDisplay } from '@principle-theorem/principle-core/interfaces';
import { MohFormViewerComponent } from '../moh-form-viewer/moh-form-viewer.component';

@Component({
  selector: 'pr-moh-view-forms-dialog',
  imports: [MohFormViewerComponent, NgDialogModule],
  templateUrl: './moh-view-forms-dialog.component.html',
  styleUrl: './moh-view-forms-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohViewFormsDialogComponent {
  forms = inject<IMohFormDisplay[]>(MAT_DIALOG_DATA);
}
